export const SALES_DEAL_PIPELINE = 'default'; // sales pipeline

export const TAXES_DEAL_PIPELINES = [
  '21867877', // test taxes pipeline
  '16813355', // prod taxes pipeline
];
